module.exports = __webpack_public_path__ + "media/packs/images/flags/AL-0d5ad81032672eee48e5be7aa42da47d.svg";